module.exports = __webpack_public_path__ + "img/Horovice.72589bb0.png";